import React from 'react';
import { checkIfCustomer } from 'src/scripts/utils/helpers';
import { AccessHeroContentData } from './AccessHero';

const LoyaltySteps = ({ options }: { options?: AccessHeroContentData }) => {
  const isSignedIn = checkIfCustomer();
  const stepsList = isSignedIn ? options?.authenticatedNumberedList : options?.unauthenticatedNumberedList;
  if (!stepsList) return null;
  const { textContent } = stepsList;

  return (
    <div className="loyalty-steps">
      <h2 className="title h2">How It Works</h2>
      <div className="steps">
        {textContent.map((item, index) => (
          <div className="step-wrapper" key={`step-${index}`}>
            <div>
              <p className="text">{index + 1}</p>
            </div>
            <div className="paragraph">{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoyaltySteps;
